<script>
  import { isDev, imgSrc } from '$client';
  export let data;

  const createStep = () => ({
    title: 'Согласование стоимости поездки в вашу сторону',
    paragraph:
      "Вы подаёте заявку на вывоз ненужных вещей. Это можно сделать по номеру телефона, оставить заявку в форме обратной связи или написать нам в What's Up / Viber.",
    img: {
      data: {
        id: 1,
        attributes: {
          alternativeText: '',
          url: '',
        },
      },
    },
  });

  if (!data && isDev()) data = { header: 'Как мы работаем', data: Array(3).fill({}).map(createStep) };
</script>

{#if data}
  <section class="how-we-work container logo-pattern">
    <h2 class="h2">{data.header}</h2>
    <ul>
      {#each data.data as step, i}
        <li class="how-we-work-article">
          <p class="counter">{'0' + (i + 1)}</p>
          <img
            loading="lazy"
            height={step.img.data.attributes.height}
            width={step.img.data.attributes.width}
            src={imgSrc(step.img.data.attributes.url)}
            alt={step.img.data.attributes.alternativeText} />
          <div>
            <h3>{step.header}</h3>
            <p>{step.description}</p>
          </div>
        </li>
      {/each}
    </ul>
  </section>
{/if}

<style lang="scss">
  .how-we-work {
    display: flex;
    flex-direction: column;
    gap: 50px;
    padding-block: 80px;
  }

  h2 {
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
  }

  h3 {
    color: #2c333c;
    font-weight: bold;
    font-size: 20px;
    font-family: Vela Sans;

    @media only screen and (max-width: 1199.98px) {
      font-size: 16px;
    }
  }

  .counter {
    position: absolute;
    top: 20px;
    left: 20px;
    color: #f6f7f8;
    font-weight: 800;
    font-size: 36px;
    font-family: Vela Sans;

    @media only screen and (max-width: 1199.98px) {
      font-size: 28;
    }
  }

  .how-we-work-article {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 293px;
  }

  .how-we-work-article:not(:last-child)::after {
    position: absolute;
    top: 25%;
    left: calc(100% + 25px);
    width: 52px;
    height: 52px;
    background-image: url('https://admin.uberi.pro/uploads/arrow_Right_856aaed20b_a44614ed79_8048b7be19.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    content: '';

    @media only screen and (max-width: 1199.98px) {
      top: 20%;
      left: calc(100% + 5px);
      width: 32px;
      height: 32px;
    }
  }

  .how-we-work-article > div {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: calc(100% - 40px);
    margin-top: -20%;
    padding: 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 2px 10px 0 #0022421a;
  }

  .how-we-work-article > div > p {
    color: #2c333c;
    font-size: 16px;
    font-family: Roboto;
    line-height: 135%;

    @media only screen and (max-width: 1199.98px) {
      font-size: 14px;
    }
  }

  img {
    width: 100%;
    height: 240px;
    object-fit: cover;
    border-radius: 15px;

    @media only screen and (max-width: 1199.98px) {
      height: 171px;
    }
  }

  .how-we-work > ul {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 100px;
    justify-content: space-between;
    overflow: auto hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    @media only screen and (max-width: 1199.98px) {
      gap: 40px;
    }
  }
</style>
